import React from 'react'
import moment from 'moment'
import ChatHeader from './ChatHeader'
import './styles/ThreadListWindow.css'
import './styles/ChannelMessages.css'

const ThreadListWindow = ({
    threads,
    onClose,
    onSelectThread,
    readReceipts = [],
    channelId
}) => {
    const currentReceipt = readReceipts.find(r => r.rid === channelId)
    const unreadThreadIds = currentReceipt?.tunread || []

    return (
        <div className="thread-list-window">
            <ChatHeader title="All Threads" onBack={onClose} />
            <div className="thread-list-content">
                {threads.map(thread => {
                    const isUnread = unreadThreadIds.includes(thread._id)
                    return (
                        <div
                            key={thread._id}
                            className="thread-list-item"
                            onClick={() => {
                                onSelectThread(thread)
                            }}
                        >
                            <div className="message-header">
                                <span className="message-sender">
                                    {thread.u?.name || 'Unknown'}
                                </span>
                                <span className="message-timestamp">
                                    {moment(thread.ts).format('MMM DD, YYYY h:mm A')}
                                </span>
                            </div>
                            <div
                                className="message-content"
                                dangerouslySetInnerHTML={{ __html: thread.msg }}
                            />
                            <div className="message-replies">
                                {thread.tcount === 1
                                    ? '1 reply'
                                    : `Replies: ${thread.tcount || 0}`}
                                {isUnread && <span className="blue-dot" />}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ThreadListWindow
